<script setup>
//import { watch } from 'vue'
import { addIcon, deleteIcon } from '../../utils/icons';

import { useTestStore } from '../../stores/TestStore';
const testStore = useTestStore();

const props = defineProps({
  seccion_id: Number,
})

// Si cambian las dimensiones, actualizamos las puntuaciones de las respuestas
// watch(props.dimensiones, (dimensiones_new) => {

//   let puntuaciones_new = [];
//   for(let i = 0; i < dimensiones_new.length; i++) {
//     let dim_new = dimensiones_new[i];
//     let dim = props.respuesta.puntuaciones.find((d) => d.dimension_id == dim_new.id)
//     puntuaciones_new.push({"dimension_id": dim_new.id, "puntos": dim == undefined ? 0 : dim.puntos })
//   }

//    props.respuesta.puntuaciones = puntuaciones_new;

// })


</script>

<template>

  <div class="respuestas-test pl-8 my-12">

    <div class="flex justify-between border-b-2 mb-5 pb-2">
      <h5 class="font-bold text-blue-700">Respuestas</h5> 
      <button class="button-text-icon-sm" type="button" @click="testStore.add_respuesta(seccion_id)">
        <i v-html='addIcon'></i><span class="mx-2">Añadir</span>
      </button>
    </div>

    <div class="respuesta-test mb-1 space-x-4 font-bold flex" >
      <div class="w-1/2">Respuesta</div>
      <div class="w-32">Puntos</div>
      <div class="w-32">Punt. inversa</div>
    </div>

    <div v-for="respuesta in testStore.respuestas_seccion(seccion_id)" :key="respuesta.id"
      class="respuesta-test mb-1 flex space-x-4" >
       
        <input class="input-f w-1/2" v-model="respuesta.text" type="text" placeholder="Respuesta">
        <input class="input-f w-32" v-model="respuesta.puntos" type="number" placeholder="Puntos">
        <input class="input-f w-32" v-model="respuesta.puntos_inverso" type="number" placeholder="Punt. inverso">
        
        
        <div class="w-12">
          <span class="button-icon-out-gray-red" type="button" @click="testStore.delete_respuesta(respuesta.id)">
            <i v-html='deleteIcon'></i>
          </span>    
        </div>
    </div>

  </div>




</template>
 

<style lang="scss">

</style>